import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Anchor } from 'lucide-react';
import { navLinks } from '../data/mock';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [time, setTime] = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const t = setInterval(() => {
      const d = new Date();
      setTime(d.toUTCString().split(' ')[4] + ' UTC');
    }, 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? 'bg-[#05080d]/90 backdrop-blur-xl border-b border-cyan-500/15' : 'bg-transparent'
      }`}
    >
      {/* Top status bar */}
      <div className="hidden md:flex items-center justify-between px-6 py-1.5 text-[10px] font-mono tracking-[0.2em] text-cyan-400/70 border-b border-cyan-500/10">
        <div className="flex items-center gap-6">
          <span className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 blink" />
            SİSTEM AKTİF
          </span>
          <span>LAT 41.0082°N</span>
          <span>LON 28.9784°E</span>
          <span>DEPTH 0042 M</span>
        </div>
        <div className="flex items-center gap-6">
          <span>{time || '00:00:00 UTC'}</span>
          <span className="text-cyan-300">UTKU — SSK CLASS</span>
        </div>
      </div>

      {/* Main nav */}
      <div className="flex items-center justify-between px-4 md:px-8 py-4">
        <a href="#hero" className="flex items-center gap-3 group">
          <div className="relative w-9 h-9 border border-cyan-400/40 flex items-center justify-center">
            <Anchor className="w-4 h-4 text-cyan-400" />
            <div className="absolute -top-0.5 -left-0.5 w-2 h-2 border-l border-t border-cyan-300" />
            <div className="absolute -bottom-0.5 -right-0.5 w-2 h-2 border-r border-b border-cyan-300" />
          </div>
          <div>
            <div className="font-display text-xl font-bold tracking-[0.2em] text-white leading-none">UTKU</div>
            <div className="text-[9px] font-mono tracking-[0.3em] text-cyan-400/60 mt-0.5">SUBMARINE · TR-2026</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link, i) => (
            <a
              key={link.href}
              href={link.href}
              className="relative px-4 py-2 text-[11px] font-mono tracking-[0.25em] text-slate-300 hover:text-cyan-300 transition-colors group"
            >
              <span className="text-cyan-400/50 mr-2">0{i + 1}</span>
              {link.label}
              <span className="absolute left-1/2 -translate-x-1/2 bottom-1 w-0 h-px bg-cyan-400 group-hover:w-[70%] transition-all duration-300" />
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a
            href="#contact"
            className="relative inline-flex items-center gap-2 px-5 py-2.5 border border-cyan-400/50 text-cyan-300 text-[11px] font-mono tracking-[0.2em] hover:bg-cyan-400/10 transition-colors"
          >
            <span className="w-1.5 h-1.5 bg-cyan-400 blink" />
            İLETİŞİM KUR
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden w-10 h-10 border border-cyan-400/40 flex items-center justify-center text-cyan-300"
          aria-label="menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="lg:hidden overflow-hidden bg-[#05080d]/95 border-t border-cyan-500/20"
          >
            <nav className="flex flex-col px-6 py-6 gap-1">
              {navLinks.map((link, i) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="py-3 text-sm font-mono tracking-[0.2em] text-slate-300 border-b border-cyan-500/10"
                >
                  <span className="text-cyan-400/60 mr-3">0{i + 1}</span>
                  {link.label}
                </a>
              ))}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
